import type { ComponentProps, ComponentRef } from 'react';
import { forwardRef } from 'react';

import { CaretDownIcon } from '~components/icons/CaretDownIcon';
import { Button } from '~modules/media-library/view/Button';

export const SortButton = forwardRef<
  ComponentRef<typeof Button>,
  Omit<ComponentProps<typeof Button>, 'className' | 'variant'>
>(function SortButton({ children, ...ButtonProps }, ref) {
  return (
    <Button className="ml--sort-button" variant="link" {...ButtonProps} ref={ref}>
      {children}
      <CaretDownIcon className="w-4 h-4 ml-1" />
    </Button>
  );
});
